import {detail, list} from "@mc/mc-legacy";
import QsignPracovnikApi from "../api/gen/qsign/QSignPracovnikApi";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";

export const QSIGN_PRACOVNICI = "qsignPracovnici";
export const SELECTED_PRACOVNIK_TO_FILTER = "selectedPracovnikToFilter";

export function fetchPracovniciIfNeeded(force = false) {
    return (dispatch, getState) => {
        dispatch(
            list.SimpleListActions.fetchIfNeeded(
                QSIGN_PRACOVNICI,
                null,
                (parent, filter) => {
                    return QsignPracovnikApi.findAllSigners();
                },
                force
            )
        );
    };
}
export function invalidate() {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(SELECTED_PRACOVNIK_TO_FILTER, 0));
    };
}
export function setPracovnikToFilter(data) {
    return detail.DetailActions.setData(SELECTED_PRACOVNIK_TO_FILTER, 0, data);
}
